import { styled } from '@mui/material/styles';

export const DropzoneWrapper = styled('div')(({ theme }) => ({
	outline: 'none',
	overflow: 'hidden',
	position: 'relative',
	padding: theme.spacing(5, 1),
	borderRadius: theme.shape.borderRadius,
	transition: theme.transitions.create('padding'),
	background: theme.palette.background.paper,
	border: `1px dashed ${theme.palette.secondary.main}`,
	'&:hover': { opacity: 0.72, cursor: 'pointer' },
}));
